import Swiper from "swiper";
import { Thumbs, Navigation, Pagination } from "swiper/modules";

$(document).ready(function () {
	const historyThumbSlider = new Swiper(".history-thumb-slider .swiper", {
		slidesPerView: 4,
		spaceBetween: 16,
		slideToClickedSlide: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		breakpoints: {
			768: {
				slidesPerView: 4,
			},
			1024: {
				slidesPerView: 5,
				spaceBetween: 0,
			},
		},
	});

	const historyContentSlider = new Swiper(".history-content-slider .swiper", {
		modules: [Thumbs, Navigation, Pagination],
		observer: true,
		observeParents: true,
		thumbs: {
			swiper: historyThumbSlider,
		},
		pagination: {
			el: ".history-thumb-slider .swiper-pagination",
			clickable: true,
			type: "progressbar",
		},
		navigation: {
			nextEl: ".history-content-slider .swiper-btn-next",
			prevEl: ".history-content-slider .swiper-btn-prev",
		},
		slidesPerView: 1,
		spaceBetween: 16,
		breakpoints: {
			1024: {
				spaceBetween: 138,
			},
		},
		on: {
			slideChange: function () {
				let activeIndex = this.activeIndex + 1;

				let nextSlide = $(
					`.history-thumb-slider .swiper-slide:nth-child(${
						activeIndex + 1
					})`
				);
				let prevSlide = $(
					`.history-thumb-slider .swiper-slide:nth-child(${
						activeIndex - 1
					})`
				);

				if (nextSlide && !nextSlide.hasClass("swiper-slide-visible")) {
					this.thumbs.swiper.slideNext();
				} else if (
					prevSlide &&
					!prevSlide.hasClass("swiper-slide-visible")
				) {
					this.thumbs.swiper.slidePrev();
				}
			},
		},
	});
});
